import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMalaria.module.css"
import Utils from "../../../../../../../utils/Utils";
import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";


class EsitoTerapiaMalaria extends React.Component {

    state = {
        esitoTerapia: {
            specie: "",
            terapia: "",
            farmacoResistenza: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this)

    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.terapiaMalaria) {
            let esitoTerapia = this.state.esitoTerapia
            let esitoTerapiaProps = this.props.segnalazioneCopia.schedaSpeciale.terapiaMalaria

            esitoTerapia.specie = esitoTerapiaProps.specie ? esitoTerapiaProps.specie : this.state.esitoTerapia.specie
            esitoTerapia.terapia = esitoTerapiaProps.terapia ? esitoTerapiaProps.terapia : this.state.esitoTerapia.terapia
            esitoTerapia.farmacoResistenza = esitoTerapiaProps.farmacoResistenza ? esitoTerapiaProps.farmacoResistenza : this.state.esitoTerapia.farmacoResistenza

            this.setState({esitoTerapia: esitoTerapia});

        }

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setTerapiaMalaria(this.state.esitoTerapia, oggetto)
    }

    createOggettoBE() {
        let esitoTerapia = JSON.parse(JSON.stringify(this.state.esitoTerapia))
        let esitoTerapiaBe = Utils.removeEmptyValueFromObject(esitoTerapia)
        return Utils.removeFieldFromObject(esitoTerapiaBe, "corretto")
    }

    controlloDati() {
        let esitoTerapia = this.state.esitoTerapia
        esitoTerapia.corretto = []

        if (!esitoTerapia.specie) {
            esitoTerapia.corretto[0] = "Campo \"Specie Plasmodio\" mancante o errato";
        }
        this.setState({esitoTerapia: esitoTerapia})
    }

    riceviValore(field, event) {
        let esitoTerapia = this.state.esitoTerapia
        if (field.currentTarget) {
            esitoTerapia[field.currentTarget.id] = field.currentTarget.value
        } else {
            esitoTerapia[field] = event.target.value
        }
        this.setState({esitoTerapia: esitoTerapia})
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setTerapiaMalaria(this.state.esitoTerapia, oggetto)
    }

    riceviValoreRadioButton(event, field) {
        let esitoTerapia = this.state.esitoTerapia
        esitoTerapia[field] = event
        this.setState({esitoTerapia: esitoTerapia})
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setTerapiaMalaria(this.state.esitoTerapia, oggetto)
    }


    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div style={{marginTop: "1rem"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.Specie.specie")}
                                    <span className={stylesWelcome.mandatoryColor}>*</span></p>
                                <div className="row">
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"specie1"}
                                                     name={"specie"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.Specie.falciparum")}
                                                     value={"1"}
                                                     onClick={() => this.riceviValoreRadioButton("specie1", "specie")}
                                                     checked={this.state.esitoTerapia.specie === "specie1"}
                                        />
                                    </div>
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"specie2"}
                                                     name={"specie"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.Specie.vivax")}
                                                     value={"2"}
                                                     onClick={() => this.riceviValoreRadioButton("specie2", "specie")}
                                                     checked={this.state.esitoTerapia.specie === "specie2"}
                                        />
                                    </div>
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"specie3"}
                                                     name={"specie"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.Specie.ovale")}
                                                     value={"3"}
                                                     onClick={() => this.riceviValoreRadioButton("specie3", "specie")}
                                                     checked={this.state.esitoTerapia.specie === "specie3"}
                                        />
                                    </div>
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"specie4"}
                                                     name={"specie"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.Specie.malaria")}
                                                     value={"4"}
                                                     onClick={() => this.riceviValoreRadioButton("specie4", "specie")}
                                                     checked={this.state.esitoTerapia.specie === "specie4"}
                                        />
                                    </div>
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"specie5"}
                                                     name={"specie"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.Specie.forme")}
                                                     value={"5"}
                                                     onClick={() => this.riceviValoreRadioButton("specie5", "specie")}
                                                     checked={this.state.esitoTerapia.specie === "specie5"}
                                        />
                                    </div>
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"specie6"}
                                                     name={"specie"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.Specie.nonSpecificabile")}
                                                     value={"6"}
                                                     onClick={() => this.riceviValoreRadioButton("specie6", "specie")}
                                                     checked={this.state.esitoTerapia.specie === "specie6"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione2 = (

            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.terapia")}
                            </p>
                            <Input type={"textarea"} class="form-group" rows="3"
                                   id={"terapia"}
                                   onChange={this.riceviValore}
                                   field={"terapia"}
                                   value={this.state.esitoTerapia.terapia}
                                   placeholder={t("GestioneFocolai.informazione.inserisciNote")}/>
                        </div>
                    </div>
                </div>
            </div>

        );

        const sezione3 = (

            <div style={{paddingTop: "1rem"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaFlussoSpeciale.Malaria.EsitoTerapia.farmaco")}
                            </p>
                            <Input type={"textarea"} class="form-group" rows="3"
                                   id={"farmacoResistenza"}
                                   onChange={this.riceviValore}
                                   field={"farmacoResistenza"}
                                   value={this.state.esitoTerapia.farmacoResistenza}
                                   placeholder={t("GestioneFocolai.informazione.inserisciNote")}/>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                {sezione1}
                {sezione2}
                {sezione3}
            </div>

        )
    }

}

export default withTranslation('common')(EsitoTerapiaMalaria)
